export enum StorageLocationPutawayMode {
  ScanEach = "scan_each",
  MoveAll = "move_all",
}
